import { sendRequest, sendRequestAsync } from "../apiService";

export async function getAutoResponseSettingsAsync() {
    try {
        const response = await sendRequestAsync(
            {
                request: {
                    resource: `/charities/me/donors/messages/auto-response`,
                    method: "get",
                },
            },
            { supressAlert: true }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function updateAutoResponseSettingsAsync(autoResponseEnabled, autoResponseMessage) {
    try {
        await sendRequestAsync(
            {
                request: {
                    resource: `/charities/me/donors/messages/auto-response`,
                    method: "put",

                },
                data: {
                    autoResponseEnabled,
                    autoResponseMessage
                }
            },
            { supressAlert: true }
        );
    } catch (error) {
        throw error;
    }
}

export function getMessageThreads(callback) {
    sendRequest({
        request: {
            resource: "/charities/me/donors/messages/",
            method: "get",
        },
        data: null,
        success: (response) => {
            if (callback) callback(response);
        },
    });
}

export async function getMessageThreadsAsync(batchSize, lastThreadId, lastMessageDate, searchTerm) {
    try {
        const queryParams = new URLSearchParams();
        queryParams.append('batchSize', batchSize);

        if (lastThreadId) {
            queryParams.append('lastThreadId', lastThreadId);
        }

        if (lastMessageDate) {
            queryParams.append('lastMessageDate', lastMessageDate);
        }

        if (searchTerm) {
            queryParams.append('searchTerm', searchTerm);
        }

        const response = await sendRequestAsync(
            {
                request: {
                    resource: `/charities/me/donors/messages/?${queryParams.toString()}`,
                    method: "get",
                },
                data: null,
            },
            { supressAlert: true }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function getUnreadMessageThreadsAsync() {
    try {
        const response = await sendRequestAsync(
            {
                request: {
                    resource: "/charities/me/donors/messages/unread",
                    method: "get",
                },
                data: null,
            },
            { supressAlert: true }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
}

export function getMessageThread(donorId, callback) {
    sendRequest({
        request: {
            resource: `/charities/me/donors/${donorId}/messages`,
            method: "get",
        },
        data: null,
        success: (response) => {
            if (callback) callback(response);
        },
    });
}

export function sendMessage(donorId, message, callback) {
    sendRequest({
        request: {
            resource: `/charities/me/donors/${donorId}/messages`,
            method: "post",
        },
        data: { message },
        success: (response) => {
            if (callback) callback(response);
        },
    });
}

export async function markThreadAsReadAsync(threadId) {
    try {
        const response = await sendRequestAsync({
            request: {
                resource: `/charities/me/donors/messages/${threadId}/read`,
                method: "post",
            },
            data: null,
        },
            { supressAlert: true }
        );
        return response;
    } catch (error) {
        throw error;
    }
}

export async function markThreadAsUnreadAsync(threadId) {
    try {
        const response = await sendRequestAsync(
            {
                request: {
                    resource: `/charities/me/donors/messages/${threadId}/unread`,
                    method: "post",
                },
                data: null,
            },
            { supressAlert: true }
        );
        return response;
    } catch (error) {
        throw error;
    }
}

export async function archiveThreadAsync(threadId) {
    try {
        const response = await sendRequestAsync(
            {
                request: {
                    resource: `/charities/me/donors/messages/${threadId}/archive`,
                    method: "put",
                },
                data: null,
            },
            { supressAlert: true }
        );
        return response;
    } catch (error) {
        throw error;
    }
}

export async function getMessageThreadAsync(donorId, lastMessageDate) {
    try {
        let url = `/charities/me/donors/${donorId}/messages`;
        if (lastMessageDate) {
            const dateParam = encodeURIComponent(lastMessageDate);
            url += `?lastMessageDate=${dateParam}`;
        }
        const response = await sendRequestAsync({
            request: {
                resource: url,
                method: "get",
            },
            data: null,
        }, { supressAlert: true });
        return response.data;
    } catch (error) {
        throw error;
    }
}